import React, { useState } from "react";
import "./style.scss";
import { Button } from "@mui/material";
import PreviewForm from "./Preview";

const ConfirmationPopup = ({
  isConfirmPopup,
  handleSubmitCall,
  handleClose,
  previewData,
}) => {
  const [isNextOpen, setNextOpen] = useState(false);

  const handleNextStep = (step) => {
    if (step === 1) {
      setNextOpen(true);
    } else {
      handleClose();
      setNextOpen(false);
    }
  };

  return (
    <React.Fragment>
      {isNextOpen ? (
        <div className="confirmation-container">
          <div className="header">Warning</div>
          <div className="container">
            {isConfirmPopup?.status ? (
              <>
                <div className="text">
                  The form you are trying to open is already submitted.
                </div>
                <div className="text">
                  Resending the form would override existing data.
                </div>
              </>
            ) : (
              <>
                <div className="text">Do you wish to submit your form?</div>
                <div className="text">
                  The form once submitted cannot be edited.
                </div>
              </>
            )}
          </div>
          <div className="button-container">
            <Button
              variant="contained"
              className="btn-yes"
              sx={{ px: 6 }}
              onClick={handleSubmitCall}
            >
              Yes
            </Button>
            <Button
              variant="contained"
              className="btn-no"
              sx={{ px: 6 }}
              onClick={() => {
                handleClose();
                setTimeout(() => {
                  setNextOpen(false);
                }, 100);
              }}
            >
              No
            </Button>
          </div>
        </div>
      ) : (
        <PreviewForm
          handleNextStep={handleNextStep}
          previewData={previewData}
        />
      )}
    </React.Fragment>
  );
};

export default ConfirmationPopup;
